import {equals, flow, makeGet, noop} from '@logistics-frontend/utils'

import {SharedRouteInfoResponse as RouteInfo} from 'src/api/cargo-c2c/types'

export * from './network'
export * from './tagToUrl'

export const infoGet = makeGet<RouteInfo>()
export const isBannerPositionUp: (routeInfo: RouteInfo) => boolean = flow(
  infoGet('promo_banner.banner_position'),
  equals('up'),
)

// если кому-то понадобится еще, то можно унеси в общие утилзы
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
export function withResolvers<V = unknown, E = unknown>() {
  let resolve: (value: V) => void = noop
  let reject: (error?: E) => void = noop

  return {
    promise: new Promise<V>((_resolve, _reject) => {
      resolve = _resolve
      reject = _reject
    }),
    resolve,
    reject,
  } as const
}
